// OcipError.jsx  (GrowattError)
import "./OcipError.css";
import React from "react";
import { useSelector } from "react-redux";
import { getIvFieldValue } from "../../utils/ivErrorDataUtils";

const GrowattError = ({ SelInverter }) => {
  const ivData  = useSelector((state) => state.ivData  || {});

  // 필드 값 안전하게 꺼내기: 배열(인버터별)도, 단일값도 대응
  const getField = (name) => getIvFieldValue(ivData, name, SelInverter);

  // 사진처럼 2열 구성
  const itemsLeft = [
    { label: "인버터 동작", key: "state" },  // state: 1=정상
    { label: "105 (Error0)", key: "Pfault" },
    { label: "106 (Error1)", key: "fault0" },
    { label: "107 (Error2)", key: "fault1" },
  ];
  const itemsRight = [
    { label: "110 (Error3)", key: "fault2" },
    { label: "111 (Error4)", key: "fault3" },
    { label: "112 (Error5)", key: "fault4" },
  ];

  // 이상 판정: state는 1이 정상, 그 외는 0이 정상
  const isAbnormal = (item, value) => {
    const n = Number(value);
    if (!Number.isFinite(n)) return false;
    if (item.key === "state") return n !== 1; // state만 1이 정상
    return n !== 0;                            // 나머지는 0이 정상
  };

  const RowItem = ({ item }) => {
    const value = getField(item.key);
    const abnormal = isAbnormal(item, value);
    return (
      <div className="status-item">
        <span className="status-value">
          {item.label}: {value ?? "-"}
        </span>
        <span className={abnormal ? "blinking-icon" : ""}>
          {abnormal ? "🔴" : "🟢"}
        </span>
      </div>
    );
  };

  return (
    <div className="status-list-container">
      <div className="status-list">
        {itemsLeft.map((it) => (
          <RowItem key={it.key} item={it} />
        ))}
        {itemsRight.map((it) => (
          <RowItem key={it.key} item={it} />
        ))}
      </div>
    </div>
  );
};

export default GrowattError;
